export default __webpack_public_path__ + "static/media/flag-17.eb0f3bb3.gif";